// extracted by mini-css-extract-plugin
export default {"thumbnail":"PxYra9M5RoTah__tYlYg","selected":"NEpQWoOWHSyBLIIPnfSN"};